export const isFromEmailCampaign = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  const promoParam = urlParams.get("promo");
  return promoParam === "shopMoreSaveMore";
};

export const getNewSubscriptionDiscountCode = (): string => {
  return "xtra10off";
};

export const shouldApplyNewSubscriptionDiscount = (): boolean => {
  // Check localStorage first, then URL parameter
  const storedValue = localStorage.getItem("shop_more_save_more");

  return storedValue === "1" || isFromEmailCampaign();
};

export const clearShopMoreSaveMoreCookie = (): void => {
  localStorage.removeItem("shop_more_save_more");
};
